import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { UygulamaHataSiniri } from './components/layout/hata-ekrani';
import { PazarBaglantisi } from './components/layout/pazar-baglantisi';
import { pazarYukle } from './lib/pazar';
import { sunumModunuYukle } from './lib/sunum';
import { temayiIzle } from './lib/theme';
import './styles/globals.css';

// Sunum modu açık bırakıldıysa ilk çizimde bile kâr görünmesin
sunumModunuYukle();
temayiIzle();

const container = document.getElementById('root');
if (!container) throw new Error('#root bulunamadı');

const root = createRoot(container);
root.render(<PazarBaglantisi />);

// Pazar para gösterimini ve Amazon bağlantılarını belirliyor: cevap gelmeden uygulama çizilmiyor
void pazarYukle(() => root.render(<PazarBaglantisi ulasilamadi />)).then(() => {
  root.render(
    <StrictMode>
      <UygulamaHataSiniri>
        <App />
      </UygulamaHataSiniri>
    </StrictMode>,
  );
});
